require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[26],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(273);


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _GlobalToast = _interopRequireDefault(__webpack_require__(99));

exports["default"] = _GlobalToast["default"];
exports.GlobalToast = _GlobalToast["default"];

var _GlobalToastContainer = _interopRequireDefault(__webpack_require__(278));

exports.GlobalToastContainer = _GlobalToastContainer["default"];

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(275);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-globaltoast{position:fixed;top:16px;right:16px;z-index:9000;background:#fff}.ba-common-globaltoast.is-not-found{display:none}.ba-common-globaltoast.is-stackable{position:relative;margin-bottom:8px;top:auto;right:auto}.ba-common-globaltoast.bx--toast-notification .bx--toast-notification__subtitle{color:#161616}.ba-common-globaltoast.bx--toast-notification .bx--toast-notification__close-icon{fill:#161616}.ba-common-globaltoast.bx--toast-notification .bx--toast-notification__details{color:#161616}\n", ""]);

// exports
exports.locals = {
	"globalToastClassName": "\"ba-common-globaltoast\""
};

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _GlobalToastResources = _interopRequireDefault(__webpack_require__(277));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_GlobalToastResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

var amdi18n={"__root":{"close":"Close","information":"Information","success":"Success","warning":"Warning","error":"Error"},"__cs":{"close":"Zavřít","information":"Informace","success":"Úspěch","warning":"Varování","error":"Chyba"},"__da":{"close":"Luk","information":"Information","success":"Udført","warning":"Advarsel","error":"Fejl"},"__de":{"close":"Schließen","information":"Information","success":"Erfolg","warning":"Warnung","error":"Fehler"},"__es":{"close":"Cerrar","information":"Información","success":"Correcto","warning":"Aviso","error":"Error"},"__fi":{"close":"Sulje","information":"Tiedot","success":"Onnistui","warning":"Varoitus","error":"Virhe"},"__fr":{"close":"Fermer","information":"Information","success":"Succès","warning":"Avertissement","error":"Erreur"},"__hr":{"close":"Zatvori","information":"Informacije","success":"Uspješno","warning":"Upozorenje","error":"Greška"},"__hu":{"close":"Bezárás","information":"Információ","success":"Sikeres","warning":"Figyelmeztetés","error":"Hiba"},"__it":{"close":"Chiudi","information":"Informazioni","success":"Esito positivo","warning":"Avvertenza","error":"Errore"},"__ja":{"close":"閉じる","information":"情報","success":"完了","warning":"警告","error":"エラー"},"__kk":{"close":"Жабу","information":"Information","success":"Success","warning":"Warning","error":"Error"},"__ko":{"close":"닫기","information":"정보","success":"성공","warning":"경고","error":"오류"},"__nb":{"close":"Lukk","information":"Informasjon","success":"Vellykket","warning":"Advarsel","error":"Feil"},"__nl":{"close":"Sluiten","information":"Informatie","success":"Gelukt","warning":"Waarschuwing","error":"Fout"},"__no":{"close":"Lukk","information":"Informasjon","success":"Vellykket","warning":"Advarsel","error":"Feil"},"__pl":{"close":"Zamknij","information":"Informacja","success":"Pomyślne wykonanie","warning":"Ostrzeżenie","error":"Błąd"},"__pt":{"close":"Fechar","information":"Informações","success":"Evento","warning":"Aviso","error":"Erro"},"__pt-br":{"close":"Fechar","information":"Informações","success":"Evento","warning":"Aviso","error":"Erro"},"__ro":{"close":"Închidere","information":"Informaţii","success":"Succes","warning":"Avertisment","error":"Eroare"},"__ru":{"close":"Закрыть","information":"Информация","success":"Успешно","warning":"Предупреждение","error":"Ошибка"},"__sl":{"close":"Zapri","information":"Informacije","success":"Uspešno","warning":"Opozorilo","error":"Napaka"},"__sv":{"close":"Stäng","information":"Information","success":"Klar","warning":"Varning","error":"Fel"},"__th":{"close":"ปิด","information":"ข้อมูล","success":"สำเร็จ","warning":"คำเตือน","error":"ข้อผิดพลาด"},"__tr":{"close":"Kapat","information":"Bilgi","success":"Başarılı","warning":"Uyarı","error":"Hata"},"__zh":{"close":"关闭","information":"信息","success":"成功","warning":"警告","error":"错误"},"__zh-cn":{"close":"关闭","information":"信息","success":"成功","warning":"警告","error":"错误"},"__zh-hk":{"close":"關閉","information":"資訊","success":"成功","warning":"警告","error":"錯誤"},"__zh-mo":{"close":"關閉","information":"資訊","success":"成功","warning":"警告","error":"錯誤"},"__zh-sg":{"close":"关闭","information":"信息","success":"成功","warning":"警告","error":"错误"},"__zh-tw":{"close":"關閉","information":"資訊","success":"成功","warning":"警告","error":"錯誤"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = __webpack_require__(14);

var _GlobalToast = _interopRequireDefault(__webpack_require__(99));

var _globaltoastcontainer = _interopRequireDefault(__webpack_require__(279));

var globalToastContainerClassName = _globaltoastcontainer["default"].globalToastContainerClassName.replace(/"/g, '');

var GlobalToastContainer = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(GlobalToastContainer, _Component);

  function GlobalToastContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_coordinateAdjustor", function () {
      var _this$props = _this.props,
          xOffset = _this$props.xOffset,
          yOffset = _this$props.yOffset,
          position = _this$props.position;
      var result = {};

      switch (position) {
        case 'upperLeft':
          result.left = xOffset;
          result.top = yOffset;
          break;

        case 'upperRight':
          result.right = xOffset;
          result.top = yOffset;
          break;

        default:
          break;
      }

      return result;
    });
    return _this;
  }

  var _proto = GlobalToastContainer.prototype;

  _proto.render = function render() {
    var coordinate = this._coordinateAdjustor();

    var _this$props2 = this.props,
        className = _this$props2.className,
        targetId = _this$props2.targetId,
        toasts = _this$props2.toasts;
    return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
      style: (0, _extends2["default"])({}, coordinate),
      className: globalToastContainerClassName + " " + className
    }, toasts && toasts.map(function (toastProp) {
      return /*#__PURE__*/_react["default"].createElement(_GlobalToast["default"], toastProp);
    })), document.getElementById(targetId) || document.body);
  };

  return GlobalToastContainer;
}(_react.Component);

exports["default"] = GlobalToastContainer;
(0, _defineProperty2["default"])(GlobalToastContainer, "propTypes", {
  position: _propTypes["default"].oneOf(['upperLeft', 'upperRight']),
  toasts: _propTypes["default"].array,
  xOffset: _propTypes["default"].number,
  yOffset: _propTypes["default"].number,
  targetId: _propTypes["default"].string,
  className: _propTypes["default"].string
});
(0, _defineProperty2["default"])(GlobalToastContainer, "defaultProps", {
  position: 'upperRight',
  xOffset: 0,
  yOffset: 0
});

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(280);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-globaltoastcontainer{z-index:9000;position:fixed;width:auto}\n", ""]);

// exports
exports.locals = {
	"globalToastContainerClassName": "\"ba-common-globaltoastcontainer\""
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = __webpack_require__(14);

var _baUiCarbon = __webpack_require__(12);

var _globaltoast = _interopRequireDefault(__webpack_require__(274));

var _StringResource = _interopRequireDefault(__webpack_require__(276));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var globalToastClassName = _globaltoast["default"].globalToastClassName.replace(/"/g, '');

function getStatusIconText(statusType, iconText) {
  if (iconText == null) {
    switch (statusType) {
      case 'info':
        return _StringResource["default"].get('information');

      case 'success':
        return _StringResource["default"].get('success');

      case 'warning':
        return _StringResource["default"].get('warning');

      case 'error':
        return _StringResource["default"].get('error');

      default:
        return iconText;
    }
  }

  return iconText;
}

var GlobalToast = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(GlobalToast, _Component);

  function GlobalToast(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClose", function (e) {
      var onClose = _this.props.onClose;
      onClose && onClose(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_createNode", function () {
      var _this$props = _this.props,
          statusType = _this$props.statusType,
          contentString = _this$props.contentString,
          children = _this$props.children,
          closeText = _this$props.closeText,
          className = _this$props.className,
          style = _this$props.style,
          statusIconText = _this$props.statusIconText,
          timedDismiss = _this$props.timedDismiss,
          targetId = _this$props.targetId,
          stackable = _this$props.stackable,
          milliseconds = _this$props.milliseconds;
      var dataTid = _this.props['data-tid'];
      var statusText = getStatusIconText(statusType, statusIconText);
      var targeted = targetId ? ' is-targeted' : '';
      var foundTarget = document.getElementById(targetId) && targetId || !targetId ? '' : ' is-not-found';
      return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.ToastNotification, {
        caption: null,
        title: "",
        iconDescription: closeText,
        statusIconDescription: statusText,
        subtitle: contentString,
        timeout: timedDismiss ? milliseconds : null,
        className: globalToastClassName + " " + className + " " + targeted + " " + foundTarget + " " + (stackable ? 'is-stackable' : ''),
        kind: statusType,
        children: contentString ? null : children,
        style: style,
        onCloseButtonClick: _this._onClose,
        role: "alert",
        "data-tid": dataTid
      });
    });
    _this.timerId = null;
    return _this;
  }

  var _proto = GlobalToast.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        targetId = _this$props2.targetId,
        stackable = _this$props2.stackable;
    return stackable ? this._createNode() : (0, _reactDom.createPortal)(this._createNode(), document.getElementById(targetId) || document.body);
  };

  return GlobalToast;
}(_react.Component);

exports["default"] = GlobalToast;
(0, _defineProperty2["default"])(GlobalToast, "propTypes", {
  statusType: _propTypes["default"].oneOf(['info', 'success', 'warning', 'error']),
  children: _propTypes["default"].node,
  contentString: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  closeText: _propTypes["default"].string,
  statusIconText: _propTypes["default"].string,
  timedDismiss: _propTypes["default"].bool,
  milliseconds: _propTypes["default"].number,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  startingFocusIndex: _propTypes["default"].number,
  targetId: _propTypes["default"].string,
  stackable: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(GlobalToast, "defaultProps", {
  statusType: 'success',
  contentString: '',
  timedDismiss: false,
  milliseconds: 4000,
  closeText: _StringResource["default"].get('close'),
  statusIconText: null,
  className: '',
  style: {},
  startingFocusIndex: -1,
  targetId: '',
  stackable: false
});

/***/ })

},[[272,0]]]);
});